import React, { useState, useEffect } from "react";
import './../App.css';
import Menu from './menu/menu.jsx';
import Footer from './menu/footer.jsx';
import FormulaireRecherche from './formulaireRecherche.jsx';
import { I18nPropvider, LOCALES } from './../i18nProvider';
import { useLocation, useSearchParams } from "react-router-dom";
import { columnsEn, columnsFr } from "./../constants/dataColumns.jsx";
import Banniere from "./banniere/banniere.jsx";
import TableauChaines from "./tableauChaines.jsx";


function createSetOfOrbitalesPositions(dataSatellite) {
    let setOrbitalPosition = new Set()
    let data = []
    for (let i = 0; i < dataSatellite.length; i++) {
        if (dataSatellite[i].orbitalPosition != null) {
            if (setOrbitalPosition.has(dataSatellite[i].orbitalPosition) == false) {
                setOrbitalPosition.add(dataSatellite[i].orbitalPosition)
                data.push(dataSatellite[i])
            }
        }
    }
    return data.sort((a, b) => {
        // all entries pushed in data is not null but contains degree symbol ?
        var dataA = a.orbitalPosition.split("°");
        var valueA = parseFloat(dataA[0].trim());
        var positionA = dataA[1];

        var dataB = b.orbitalPosition.split("°");
        var valueB = parseFloat(dataB[0].trim());
        var positionB = dataB[1];

        if (positionA == "W")
            valueA = valueA * -1;
        if (positionB == "W")
            valueB = valueB * -1;

        if (valueA > valueB)
            return 1;
        if (valueA < valueB)
            return -1;
        return 0;
    });
}

export function Accueil({ langue }) {
    const [lineUpData, setLineUpData] = useState([]);
    const [languages, setLanguages] = useState([]);
    const [themes, setThemes] = useState([]);
    const [satelitteData, setSatelliteData] = useState([]);
    const [autoCompleteData, setAutoCompleteData] = useState([]);
    const [searchLoading, setSearchLoading] = useState(true);
    const [searchParams, setSearchParams] = useSearchParams();
    let langParam = searchParams.get("Langue");
    let language = undefined;
    if (langParam !== undefined) {
        if (langParam === "EN") {
            language = LOCALES.ENGLISH;
        } else if (langParam === "FR") {
            language = LOCALES.FRENCH;
        }

    }
    const [locale, setLocale] = useState(language === undefined ? langue : language);
    const location = useLocation();
    const [orbitalePositionData, setOrbitalePositionData] = useState([]);
    const [columns, setColumns] = useState(columnsEn);
    const changeDatagridColumns = (lng) => {
        if (lng == LOCALES.FRENCH) {
            setColumns(columnsFr);
        }
        else if (lng == LOCALES.ENGLISH) {
            setColumns(columnsEn);
        }
    };

    useEffect(() => {
        //construit la liste déroulante des langues sans doublons et sans plusieurs langues sur la meme ligne
        function getAllLanguage(arrayLangue) {
            let aux = []
            let setLangue = new Set();
            for (var line in arrayLangue) {
                if (arrayLangue[line] != null) {
                    aux = arrayLangue[line].split("|")
                    for (var langue in aux) {
                        setLangue.add(aux[langue].trim())
                    }
                }
            }
            return setLangue;
        }

        function fetchDataSatellite() {

            fetch('/lineup/api/satellite/actif')
            .then(response => {
                response.json().then(data => {
                    setSatelliteData(data)
                    setOrbitalePositionData(
                        createSetOfOrbitalesPositions(data))
                    let satParam = searchParams.get("satellite")
                    let orbitalPosParam = searchParams.get("orbitalPositionId")
                    if (satParam != null) {
                        document.getElementById('satellite').value = satParam;
                        document.getElementsByClassName('orbitUpdateButton')[0].click();
                    }
                    else if (orbitalPosParam != null) {
                        document.getElementById('orbitalPosition').value = orbitalPosParam.toUpperCase();
                        document.getElementsByClassName('satUpdateButton')[0].click();
                    }
                })
            }).catch(err => {
                console.log("Erreur lors de la récupération des données satellites");
                console.log(err)
            })
        }


        function fetchDataLineUp() {
            const searchCriteria = {
                channelEncryption : [],
                channelResolution : [],
                channels : [],
                language : null,
                orbitalPosition : null,
                packages : [],
                satelliteName : null,
                theme : null,
                type: ["TV"]
            };

            fetch('/lineup/api/lineup/lineup-searches', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(searchCriteria),
            })
                .then(response => {
                    response.json().then(data => {
                        setLineUpData(data)
                        //setLanguages(Array.from(new Set(data.filter(item => item.language !== null).map(item => item.language))).sort());
                        setLanguages(Array.from(
                            getAllLanguage(data.filter(item => item.language !== null).map(item => item.language))
                        ).filter(item => item.length > 1).sort())
                        setThemes(Array.from(new Set(data.filter(item => item.theme !== null && item.theme !== "Adults").map(item => item.theme))).sort());
                        setSearchLoading(false)
                        fetchDataSatellite()
                    })

                }).catch(err => {
                    console.log("Erreur lors de la récupération des données lineup");
                    console.log(err)
                })



            fetch('/lineup/api/lineup/autocomplete')
                .then(response => {
                    response.json().then(data => {
                        setAutoCompleteData(data)
                    })
                }).catch(err => {
                    console.log("Erreur lors de l'appel à l'api autocomplete");
                    console.log(err)
                })
        }
        if (typeof (location.locale) != "undefined") {
            setLocale(location.locale)
            changeDatagridColumns(location.locale)
        }
        fetchDataLineUp();
    }, []);
    return (
        <I18nPropvider locale={locale}>
            <div className="App overflow-auto" >
                <header className="App-header">
                    <div>
                        <Menu locale={locale} onChangeValue={(lng) => { setLocale(lng); changeDatagridColumns(lng); }}></Menu>
                    </div>
                </header>

                <div id="autoComplete">
                    <FormulaireRecherche locale={locale} satelitteData={satelitteData} lineUpData={lineUpData}
                        autoCompleteData={autoCompleteData} languages={languages} themes={themes} orbitalePositionData={orbitalePositionData}
                        searchLoading={searchLoading}
                        onChangeValue={(data) => {
                            setLineUpData(data)
                        }}
                        onChangeSatelliteNameValue={(data) => {
                            setOrbitalePositionData(data)
                        }}
                        onChangeOrbitalPostion={(data) => {
                            setSatelliteData(data)
                        }}
                        refreshSatellite={(data) => {
                            setSatelliteData(data)
                            setOrbitalePositionData(createSetOfOrbitalesPositions(data))
                        }}
                        onSearchLoading={(data) => {                            
                            setSearchLoading(data)
                        }}>
                    </FormulaireRecherche>
                </div>

                <div className="container">
                    <TableauChaines searchLoading={searchLoading} channels={lineUpData} locale={locale} columns={columns}></TableauChaines>
                </div>

                <div className="carouselBanner">
                    <Banniere></Banniere>
                </div>

                <div className="clear"></div>

                <footer className="footer">
                    <Footer></Footer>
                </footer>
            </div>
        </I18nPropvider>
    );

}
export default Accueil;